'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.Formatting'];
module.exports = angular.module('AVRO.Dashboard.Tooltips', dependencies).factory('ChartDashboardTooltipFormattersService', require('./services/ChartDashboardTooltipFormattersService'));